import { AbstractControl, ValidatorFn } from '@angular/forms'

export function cnpjValidator(): ValidatorFn {
  return (control: AbstractControl): Record<string, any> | null => {
    const cnpj = control.value?.replace(/\D/g, '')

    if (!cnpj || cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) {
      return { invalidCnpj: { value: control.value } }
    }

    let size = cnpj.length - 2
    let numbers = cnpj.substring(0, size)
    const digits = cnpj.substring(size)
    let sum = 0
    let pos = size - 7

    for (let i = size; i >= 1; i--) {
      sum += parseInt(numbers.charAt(size - i)) * pos--
      if (pos < 2) pos = 9
    }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
    if (result !== parseInt(digits.charAt(0))) {
      return { invalidCnpj: { value: control.value } }
    }

    size = size + 1
    numbers = cnpj.substring(0, size)
    sum = 0
    pos = size - 7
    for (let i = size; i >= 1; i--) {
      sum += parseInt(numbers.charAt(size - i)) * pos--
      if (pos < 2) pos = 9
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
    if (result !== parseInt(digits.charAt(1))) {
      return { invalidCnpj: { value: control.value } }
    }

    return null
  }
}
